<template lang="pug">
	div#intro-sub-menu.exp(:class="{'sidebar-version' : full }")
		b-row
			b-col
				h2 Table of contents
		b-row
			b-col(:md="mdSize" cols="12")
				ul
					li(v-for="(innerContent, index) in content.table_of_contents" :href="innerContent.url" :class="{active:innerContent.slug == content.slug}" @click="trackCollegeSavingsBasicsClick(innerContent.title)"  :target="innerContent.slug == 'which-is-the-best-529-plan-available' ? '_blank': '_self'" v-if="index < 6")
						a(:href="innerContent.url" )
							| {{innerContent.title}}
			b-col(:md="mdSize" cols="12")
				ul
					li(v-for="(innerContent, index) in content.table_of_contents" :href="innerContent.url" :class="{active:innerContent.slug == content.slug}" @click="trackCollegeSavingsBasicsClick(innerContent.title)"  :target="innerContent.slug == 'which-is-the-best-529-plan-available' ? '_blank': '_self'"  v-if="index >= 6")
						a(:href="innerContent.url" )
							| {{innerContent.title}}
</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	#intro-sub-menu
		width: 100%
		border: 1px solid sfc-pale-gray
		padding: 30px
		margin: 30px 0
		background: bg-light-blue
		clear: both
		ul
			margin: 0
			padding: 0
			list-style: none
			li
				border-bottom: 1px solid transparent
				transition-all()
				&:hover
					border-bottom: 0px solid sfc-blue
				&.active
					&:hover
						border-bottom: 1px solid transparent
				&:last-child
					a
						border-bottom: 1px solid transparent
					@media (max-width: 768px)
						border-bottom: 1px solid sfc-pale-gray

				a
					padding-bottom: 7px
					padding-top: 7px
					margin: 0
					color: body-font-color
					display: block
					transition-all()
					font-weight: body-font-weight
					text-decoration: none
					border-bottom: 1px solid sfc-pale-gray

				&:hover
					a
						color: body-font-color
						border-bottom: 2px solid sfc-blue
				&.active
					a
						color: body-font-color
						border-bottom: 2px solid sfc-blue
						font-weight: body-font-weight-strong
		&.sidebar-version
			ul
				li
					&:last-child
						a
							border-bottom: 1px solid sfc-pale-gray
							&:hover
								color: body-font-color
								border-bottom: 2px solid sfc-blue
							&.active
								color: body-font-color
								border-bottom: 2px solid sfc-blue
								font-weight: body-font-weight-strong
</style>

<script>
	import SfcTrackingService from "@/lib/sfc-tracking-service.js"

	export default {
		props:{
			content:{
				required: true
			},
			full:{
				type: Boolean,
				default: false,
				required: false
			},
		},
		data() {
			return {
			}
		},
		computed: {
			mdSize() {
				if (this.full == true)
					return 12
				return 6
			},
		},
		mounted(){
			SfcTrackingService.trackAnalyticsAction("Intro to 529", 'show', 'Table of contents v2')
		},
		methods: {
			trackCollegeSavingsBasicsClick(section) {
				SfcTrackingService.trackBasicsClick("Intro to 529", 'Table of contents v2', section)
			}
		}
	}
</script>
